/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdminCompanyAddRemoveCourseRequestDto
 */
export interface AdminCompanyAddRemoveCourseRequestDto {
  /**
   *
   * @type {string}
   * @memberof AdminCompanyAddRemoveCourseRequestDto
   */
  courseId: string;
}

export function AdminCompanyAddRemoveCourseRequestDtoFromJSON(json: any): AdminCompanyAddRemoveCourseRequestDto {
  return AdminCompanyAddRemoveCourseRequestDtoFromJSONTyped(json, false);
}

export function AdminCompanyAddRemoveCourseRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminCompanyAddRemoveCourseRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    courseId: json["courseId"],
  };
}

export function AdminCompanyAddRemoveCourseRequestDtoToJSON(value?: AdminCompanyAddRemoveCourseRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    courseId: value.courseId,
  };
}
